/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { AddressResource } from './';
import {
    AddressResourceFromJSON,
    AddressResourceFromJSONTyped,
    AddressResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface UmbrellaCompanySearchResult
 */
export interface UmbrellaCompanySearchResult {
    /**
     * The unique identifier of the umbrella company
     * @type {string}
     * @memberof UmbrellaCompanySearchResult
     */
    id: string;
    /**
     * The name of the umbrella company
     * @type {string}
     * @memberof UmbrellaCompanySearchResult
     */
    name: string;
    /**
     * The registration number of the umbrella company
     * @type {string}
     * @memberof UmbrellaCompanySearchResult
     */
    registrationNumber?: string;
    /**
     * 
     * @type {AddressResource}
     * @memberof UmbrellaCompanySearchResult
     */
    address: AddressResource;
}

/**
 * Check if a given object implements the UmbrellaCompanySearchResult interface.
 */
export function instanceOfUmbrellaCompanySearchResult(value: object): value is UmbrellaCompanySearchResult {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    return true;
}

export function UmbrellaCompanySearchResultFromJSON(json: any): UmbrellaCompanySearchResult {
    return UmbrellaCompanySearchResultFromJSONTyped(json, false);
}

export function UmbrellaCompanySearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): UmbrellaCompanySearchResult {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'registrationNumber': json['registrationNumber'] == null ? undefined : json['registrationNumber'],
        'address': AddressResourceFromJSON(json['address']),
    };
}

export function UmbrellaCompanySearchResultToJSON(value?: UmbrellaCompanySearchResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'registrationNumber': value['registrationNumber'],
        'address': AddressResourceToJSON(value['address']),
    };
}

